import { reqConfirmRequestCartPhone, reqSendRequestCartCode } from 'cart/CartRequests'
import { reqGet } from 'HttpRequests'
import PhoneInput from 'components/inputs/PhoneInput'
import PositiveNumInput from 'components/inputs/PositiveNumInput'
import RoundButton from 'components/inputs/RoundButton'
import MySpinner from 'components/MySpinner'
import { IOrderBase } from 'order_components/IOrder'
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import CaptchaInput from 'components/inputs/CaptchaInput'

const isCodeEntered = (code: number) => {
  return code > 999 && code < 10000
}

interface IPhoneInputWithConfirmProps {
  order: IOrderBase
  onEntered: (phone: string, code: number) => void
  style?: React.CSSProperties
}

const PhoneInputWithConfirm: React.FC<IPhoneInputWithConfirmProps> = ({
  order,
  onEntered,
}) => {
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState<number | null>(null)
  const [captcha, setCaptcha] = useState('')
  const [captchaImg, setCaptchaImg] = useState('')
  const [captchaHash, setCaptchaHash] = useState('')
  const [isCodeSend, setIsCodeSend] = useState(false)

  // const [isCodeConfirmed, setIsCodeConfirmed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [timeout, setTimeout_] = useState(0)
  const [isCodeValid, setIsCodeValid] = useState(false)
  const [invalidMessage, setInvalidMessage] = useState<string | null>(null)

  useEffect(() => {
    // setIsCodeSend(false)
    // setIsCodeValid(false)
    setTimeout_(0)
  }, [order.order_id])

  useEffect(() => {
    const decreaseTimeout = () => {
      if (timeout > 0) {
        setTimeout_(timeout - 1)
      }
    }

    const timer = setTimeout(decreaseTimeout, 1000)
    return () => clearTimeout(timer)
  }, [timeout])

  useEffect(() => {
    reqGet("/api/captcha/", (resp) => {
      setCaptchaImg(resp.img)
      setCaptchaHash(resp.hash)
    })
  }, [])

  const handleChangePhone = useCallback((phone) => {
    setPhone(phone)
    setCode(null)
    setIsCodeSend(false)
    setIsLoading(false)
    setInvalidMessage(null)
    setTimeout_(0)
  }, [])

  const handleChangeCode = useCallback(
    (value) => {
      if (code === value) {
        return
      }

      setIsCodeValid(false)
      // setInvalidMessage('Подтвердите номер телефона')

      if (value === '') {
        setCode(null)
      } else {
        setCode(value)
        if (isCodeEntered(value) && phone.length) {
          setIsLoading(true)
          setMessage('')
          reqConfirmRequestCartPhone(phone, value, (response) => {
            setIsLoading(false)
            const status = response.status
            if (status === 'OK') {
              setMessage('')
              onEntered(phone, value)
              setIsCodeValid(true)
              setInvalidMessage(null)
            } else if (status === 'BAD_CODE') {
              setMessage('Неверный код или его срок действия истек')
            } else if (status === 'NOT_ACTIVE') {
              setMessage('Вход с данного номера телефона недоступен')
            } else {
              setMessage('Ошибка при подтверждении номера')
            }
          })
        }
      }
    },
    [code, phone, onEntered]
  )

  const handleSendCode = useCallback(() => {
    if (phone.length && captcha.length === 6) {
      setMessage('')
      setTimeout_(60)
      reqSendRequestCartCode(phone, captcha, captchaHash, (response) => {
        if (response.status === 'INVALID_PHONE_NUMBER') {
          setMessage('Невозможно отправить СМС-код на данный номер телефона')
          setInvalidMessage('Невозможно отправить СМС-код на данный номер телефона')
          setTimeout_(0)
        } else if (response.status === 'NOT_ACTIVE') {
          setMessage('Вход с данного номера телефона недоступен')
          setInvalidMessage('Вход с данного номера телефона недоступен')
          setTimeout_(0)
        } else if (response.status === 'CAPTCHA_ERROR') {
          setMessage('Попробуйте еще раз')
          setInvalidMessage(null)
          setTimeout_(0)
          reqGet("/api/captcha/", (resp) => {
            setCaptchaImg(resp.img)
            setCaptchaHash(resp.hash)
            setCaptcha('')
          })
        } else if (response.status !== 'OK') {
          setMessage('Невозможно отправить СМС-код подтверждения')
          setInvalidMessage('Невозможно отправить СМС-код подтверждения')
          setTimeout_(0)
        } else {
          setIsCodeSend(true)
        }
      })
    }
  }, [phone, captcha, captchaHash])

  return (
    <Form.Group>
      <Form.Label>Введите номер телефона</Form.Label>
      <Row>
        <Col sm={12} md={7} className='mb-3'>
          <PhoneInput
            isRequired
            onChange={setPhone}
            onEntered={handleChangePhone}
            invalidMessage={invalidMessage || undefined}
          />
        </Col>
        {!invalidMessage && timeout === 0 && !isCodeValid && !isLoading && (
          <Col sm={12} md={5}>
            <RoundButton color='blue' onClick={handleSendCode} disabled={!phone.length}>
              Подтвердить
            </RoundButton>
          </Col>
        )}
      </Row>

      

      {isCodeSend ? (
        <div className='mb-3'>
          <Form.Label>
            Введите Код подтверждения
            {timeout !== 0 && !isCodeValid && (
              <small> (Повторно отправить код можно через {timeout} секунд)</small>
            )}
          </Form.Label>
          <div className='d-flex align-items-center gap-2'>
            <PositiveNumInput
              value={code}
              onChange={handleChangeCode}
              disabled={isLoading}
              className={isCodeValid ? 'is-valid' : ''}
              style={{ maxWidth: '250px' }}
            />
            {isLoading && <MySpinner size='medium' />}
          </div>
          <div
            className='invalid-feedback'
            style={{ display: !!message ? 'block' : 'none' }}
          >
            {message}
          </div>
        </div>
      ) : <div className='mb-3'>
      <input type="hidden" value={captchaHash} />
        <img src={"data:image/jpeg;base64, " + captchaImg} alt="Captcha" />
        <CaptchaInput value={captcha} onChange={setCaptcha} /></div>}
    </Form.Group>
  )
}
export default PhoneInputWithConfirm
